(function() { window.GUID_dd30434a_220d_4889_bb3d_8111fe95320c = { getGuid: function() { return "dd30434a-220d-4889-bb3d-8111fe95320c"; } }; })();
var CS;
(function (CS) {
    var Analytics;
    (function (Analytics) {
        function isAnalyticsAllowed() {
            return CS.CookieConsent.CanUseAppAnalytics();
        }
        function PageView(pageUrl) {
            //Ne pas utiliser dans CS.Nav.Go car les changement de pushstate sont tracked automatiquement dans googletagmanager.com
            if (!isAnalyticsAllowed()) {
                return;
            }
            //gtag('config', gtagid, { 'page_path': pageUrl });
            if (CS.CommonData.Current.IsDebug()) {
                console.debug(`%cAnalytics.PageView - URL: ${pageUrl}`, "color: #E37400");
            }
            //Tout ceci est défini dans des variables et triggers sur googletagmanager.com
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: "GAPageView",
                url: pageUrl,
            });
        }
        Analytics.PageView = PageView;
        function Event(category, action, label, value) {
            if (!isAnalyticsAllowed()) {
                return;
            }
            //gtag('event', eventAction, {
            //    event_category: eventCategory,
            //    event_label: eventLabel,
            //    value: eventValue,
            //});
            if (CS.CommonData.Current.IsDebug()) {
                console.debug(`%cAnalytics.Event - Category: ${category}, Action: ${action}, Label: ${label}, Value: ${value}`, "color: #E37400");
            }
            if (typeof gtag === 'function') {
                //GA4
                gtag('event', action, {
                    'event_category': category,
                    'event_label': label,
                    'value': value
                });
            }
            if (window.appInsights) {
                window.appInsights.trackEvent({
                    name: action,
                    properties: {
                        category: category,
                        label: label,
                        value: value
                    }
                });
            }
            if (window.clarity) {
                if (action && label) {
                    window.clarity("set", action, label);
                }
            }
        }
        Analytics.Event = Event;
        // GA4 event with named parameters. Register each parameter reported in GA4 as a custom dimension or metric.
        function TrackEvent(name, parameters) {
            if (!isAnalyticsAllowed()) {
                return;
            }
            if (CS.CommonData.Current.IsDebug()) {
                console.debug(`%cAnalytics.TrackEvent - ${name}`, "color: #E37400", parameters);
            }
            if (typeof gtag === 'function') {
                gtag('event', name, parameters);
            }
            if (window.appInsights) {
                window.appInsights.trackEvent({
                    name: name,
                    properties: parameters
                });
            }
        }
        Analytics.TrackEvent = TrackEvent;
        function Error(message, category) {
            if (!isAnalyticsAllowed()) {
                return;
            }
            if (CS.CommonData.Current.IsDebug()) {
                console.error(`%cAnalytics.Error : ${message}`, "color: #E37400");
            }
            //TODO: Remove after july 1st 2023
            // Tout ceci est défini dans des variables et triggers sur googletagmanager.com
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: "GAEvent",
                category: category !== null && category !== void 0 ? category : "Error",
                action: "Error",
                label: message
                //'userData': userData
            });
            if (typeof gtag === 'function') {
                //GA4
                gtag('event', 'exception', {
                    'description': message,
                    'fatal': false,
                    'category': category !== null && category !== void 0 ? category : "Error"
                });
            }
            if (window.appInsights) {
                window.appInsights.trackEvent({
                    name: "Error",
                    properties: {
                        message: message,
                        category: category !== null && category !== void 0 ? category : "Error"
                    }
                });
            }
            if (window.clarity) {
                window.clarity("set", "IsInError", true);
                window.clarity("set", "Error", message);
                if (category) {
                    window.clarity("set", "ErrorCategory", category);
                }
            }
        }
        Analytics.Error = Error;
        function Purchase(provider, plan, transactionId, price, currency) {
            if (!isAnalyticsAllowed()) {
                return;
            }
            //GA4
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push('event', 'purchase', {
                'transaction_id': transactionId,
                'value': price,
                'currency': currency,
                items: [{
                        'item_name': plan,
                        'affiliation': provider,
                    }]
            });
        }
        Analytics.Purchase = Purchase;
        function Login(method) {
            if (!isAnalyticsAllowed()) {
                return;
            }
            //GA4
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push('event', 'login', {
                'method': method
            });
        }
        Analytics.Login = Login;
        function SignUp(method) {
            if (!isAnalyticsAllowed()) {
                return;
            }
            //GA4
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push('event', 'login', {
                'method': method
            });
        }
        Analytics.SignUp = SignUp;
        function Share(method, type, id) {
            if (!isAnalyticsAllowed()) {
                return;
            }
            //GA4
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push('event', 'share', {
                'method': method,
                'content_type': type,
                'item_id': id
            });
        }
        Analytics.Share = Share;
        function extractDataFromElement($element) {
            var _a, _b, _c, _d;
            if (!$element.length)
                return null;
            const category = (_a = $element.data("ga-category")) !== null && _a !== void 0 ? _a : "";
            const action = (_b = $element.data("ga-action")) !== null && _b !== void 0 ? _b : "";
            const label = (_c = $element.data("ga-label")) !== null && _c !== void 0 ? _c : undefined;
            const value = (_d = $element.data("ga-value")) !== null && _d !== void 0 ? _d : undefined;
            const valueIsNumber = Number.isInteger(value);
            const valueIsValid = typeof value === "undefined" || valueIsNumber;
            return {
                category,
                action,
                label,
                value,
                isValid: category.length > 0 && action.length > 0 && valueIsValid,
            };
        }
        Analytics.extractDataFromElement = extractDataFromElement;
    })(Analytics = CS.Analytics || (CS.Analytics = {}));
})(CS || (CS = {}));

//# sourceMappingURL=cs-analytics.js.map
